export default "__VITE_ASSET__74ef2fa1__"